/**
 * 프로젝트 관련 GraphQL 쿼리 및 뮤테이션
 */

import { gql } from "@apollo/client";

/**
 * 프로젝트 목록 조회
 */
export const PROJECTS_QUERY = gql`
  query Projects($search: String, $status: String, $page: Int, $limit: Int) {
    projects(search: $search, status: $status, page: $page, limit: $limit) {
      projects {
        _id
        number
        name
        companyId
        type
        status
        startDate
        endDate
        checkManager
        author
        createdAt
        updatedAt
      }
      total
      page
      limit
    }
  }
`;

/**
 * 프로젝트 상세 조회 (설비 현황 포함)
 * 웹(@ict/web)과 동일한 리졸버 사용
 */
export const PROJECT_QUERY = gql`
  query Project($id: ID!) {
    project(id: $id) {
      _id
      number
      name
      companyId
      type
      status
      address
      memo
      startDate
      endDate
      checkManager
      author
      witness
      createdAt
      updatedAt
    }
    projectEquipmentStatus(projectId: $id) {
      projectId
      projectName
      equipments {
        key
        title
        totalCount
        checkCount
        docsCount
        docsIds
        ratio
        unit
      }
    }
  }
`;

/**
 * 프로젝트 생성
 */
export const CREATE_PROJECT_MUTATION = gql`
  mutation CreateProject($input: CreateProjectInput!) {
    createProject(input: $input) {
      _id
      number
      name
      status
    }
  }
`;

/**
 * 프로젝트 수정
 */
export const UPDATE_PROJECT_MUTATION = gql`
  mutation UpdateProject($id: ID!, $input: UpdateProjectInput!) {
    updateProject(id: $id, input: $input) {
      _id
      number
      name
      status
      updatedAt
    }
  }
`;

/**
 * 프로젝트 삭제 (Soft Delete)
 */
export const DELETE_PROJECT_MUTATION = gql`
  mutation DeleteProject($id: ID!) {
    deleteProject(id: $id)
  }
`;

// 타입 정의
export interface ProjectsQueryVariables {
  search?: string;
  status?: string;
  page?: number;
  limit?: number;
}

export interface CreateProjectInput {
  name: string;
  type: string; // ProjectKind: "PERFORMANCE_CHECK" | "MAINTENANCE"
  startDate?: string;
  endDate?: string;
  checkManager?: string;
  author?: string;
  witness?: string;
  // companyId는 서버에서 ctx.user.companyId로 자동 설정
}

/**
 * 프로젝트 수정 입력 타입
 * @ict/shared의 UpdateProjectInput과 동일 (SSOT)
 */
export interface UpdateProjectInput {
  name?: string;
  address?: string;
  witness?: string;
  startDate?: string;
  endDate?: string;
  status?: "IN_PROGRESS" | "COMPLETED" | "PENDING";
  memo?: string;
  checkManager?: string;
}
